import {
  getSelfEnrollmentDisplayStep,
  SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS,
  SELF_ENROLLMENT_STEPS
} from '../utils/steps'
import { renderEntryStep } from './stepRenderer/renderEntrySteps'
import { renderJourneyStep } from './stepRenderer/renderJourneySteps'
import { renderOutcomeStep } from './stepRenderer/renderOutcomeSteps'
import type { FlowStepRendererProps } from './stepRenderer/types'

export function SelfEnrollmentStepRenderer({
  currentStep,
  fieldEditability,
  formData,
  updateFormData,
  locationStateMismatchWarning,
  isCheckingStepAccess,
  enrollmentState,
  docusignState,
  navigation
}: FlowStepRendererProps) {
  const stepProps = {
    onNext: navigation.onNext,
    onBack: enrollmentState.handleBack,
    currentStep: getSelfEnrollmentDisplayStep(currentStep),
    totalSteps: SELF_ENROLLMENT_DISPLAY_TOTAL_STEPS
  }

  if (currentStep <= SELF_ENROLLMENT_STEPS.CONTACT_DETAILS) {
    return renderEntryStep({
      currentStep,
      fieldEditability,
      formData,
      updateFormData,
      enrollmentState,
      navigation
    })
  }

  if (currentStep <= SELF_ENROLLMENT_STEPS.UPLOAD_DOCUMENTS) {
    return renderJourneyStep({
      currentStep,
      fieldEditability,
      formData,
      updateFormData,
      locationStateMismatchWarning,
      isCheckingStepAccess,
      enrollmentState,
      stepProps
    })
  }

  return renderOutcomeStep({
    currentStep,
    enrollmentState,
    docusignState,
    navigation,
    stepProps
  })
}
